import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "@material-ui/core";

import { RouteComponentProps } from "react-router-dom";
import Loader from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import * as api from "../../api";

import classes from "../UploadMedia/spinner.module.scss";
import { imgData } from "../UploadMedia/StaticIconName";
import { useDeviceSelectors } from "react-device-detect";
import Message from "../../storybook/Message";
import Clear from "../../assets/img/Clear.png";


interface MediaListProps extends RouteComponentProps<any> {
  wOid: any;
}
const MpegAlertUserAgents = process.env.REACT_APP_MpegAlertSupportedBrowser;

const MediaList: React.FC<MediaListProps> = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [mediaFile, setMediaFile] = useState<{}[]>([]);
  const [isOverlay, setIsOverlay] = useState("none");
  const [getWorkOrderId, setWorkOrderId] = useState<any>();
  const [base64Data, setBase64Data] = useState("");
  const [contentType, setContentType] = useState([]);
  const [isProccessing, setIsProccessing] = useState(false);
  const [isError, setIsError] = useState("");
  const [selectedId, setSelectedId] = useState();
  const videoRef: any = useRef();
  const location = useLocation();
  let inAppContent: boolean = false;
  const crypto = window.crypto;
  const [isMpegSupportedBrowser, setMpegSupportedBrowser] = useState(false);

  useEffect(() => {
    if (isError) {
      setIsOverlay("none");
    }
  }, [isError]);

  const detectedDeviceBrowser = useDeviceSelectors(window.navigator.userAgent);

  useEffect(() => {
    for (let [key, value] of Object.entries(detectedDeviceBrowser[0])) {
      if (key === MpegAlertUserAgents) {
        setMpegSupportedBrowser(value);
      }
    }
  }, []);

  const fetchMediaData = async (id: any) => {
    setIsLoading(true);
    try {
      const response = await api.getMediaData(id);
      setMediaFile(response.documents);
    } catch (e: any) {
      setIsError("View_Media_Error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setWorkOrderId(props.wOid);
    fetchMediaData(props.wOid);
  }, [location]);

  const backButtonHandler = () => {
    props.history.push({
      pathname: "/historicRepairs",
      state: { viewMediaID: location.state },
    });
  };

  /* Displaying overlay on media click */
  const displayViewMediaDetails = async (mediaId: any, content: any) => {
    setIsError("");
    setIsProccessing(true);
    setIsOverlay("block");
    setContentType(content.split("/"));
    setSelectedId(mediaId);

    try {
      const response = await api.getViewMediaDetail(getWorkOrderId, mediaId);
      const data1 = response.media.replace('"', "");

      let selectedMedia = `data:${content};base64,${data1}`;

      setBase64Data(selectedMedia);

      setIsProccessing(false);

      // istanbul ignore next Displaying pdf alert and closing overlay
      if (content.split("/")[1] === "pdf") {
        setIsOverlay("none");
        const byteCharacters = atob(data1);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: content });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      }
    } catch (e: any) {
      setIsProccessing(false);
      setIsError("View_Media_Error");
    }
  };

  const closeOverLay = () => {
    setIsOverlay("none");
    if (contentType[1] !== "mpeg" && contentType[0] === "video") {
      videoRef?.current?.pause();
    }
  };

  const displayErrorMessage = useCallback(() => {
    return (
      mediaFile.length === 0 &&
      isError && (
        <div data-testid="apierror">
          <Message className="warning-msg">
            {t(isError)}
          </Message>
        </div>
      )
    );
  }, [isError]);

  return (
    <Container id="supp-main-container"  role="main">
      {isLoading ? (
        <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
      ) : (
        <>
          <h5 >
            {t("Media_Title")}
          </h5>
          <div data-testid="media" className="media-img">
            <ul className="pb-24">
              {mediaFile.length > 0 ? (
                mediaFile?.map((data: any) => {
                  data?.metadata?.map((res: any) => {
                    if (res.key === "IsMediaAppropriate" && res.value === false) {
                      inAppContent = true;
                    }
                  });
                  return data?.metadata?.map((res: any) => {
                    if (res.key === "content-type" && inAppContent === false) {
                      const matchData = res.value.split("/");
                      return imgData.map((item: any, index: number) => {
                        if (
                          matchData[1] === item.id ||
                          matchData[1] === item.id.toUpperCase()
                        ) {
                          return (
                            <>
                                <li
                                data-testid={`detailsImg${item.id}`}
                                key={index}
                                onKeyDown={() =>
                                  displayViewMediaDetails(data.id, res.value)
                                }
                                onClick={() =>
                                  displayViewMediaDetails(data.id, res.value)
                                }
                                >
                                <img
                                  src={item.src}
                                  className="cursor-pointer"
                                  alt={`thumbnail icon${
                                  crypto.getRandomValues(new Uint32Array(1))[0] % 20
                                  }`}
                                />
                                <span className="imgName">
                                  {data.media.fileName}
                                </span>
                                </li>
                              {isError && selectedId === data.id && (
                                <Message className="warning-msg">
                                  {t(isError)}
                                </Message>
                              )}
                            </>
                          );
                        }
                      });
                    }
                    else if (inAppContent === true && res.key === "IsMediaAppropriate" && res.value === false) {
                      return (
                        <>{t("MediaRemovedMsg")}</>
                      )
                    }
                  })
                })
              ) : (
                <span> {t("No_Media")}</span>
              )

              }
            </ul>
            {displayErrorMessage()}
          </div>
        </>
      )}

      <div className="overlayPopUp" style={{ display: isOverlay }}>
        {isProccessing ? (
          <div id="UploadingOverlay">
            <div className={classes.overlayContainer}>
              <div className={classes.overlayContent}>
                <div className={classes.spinner}></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="mediaViewOverlay">
              <div className="text-end pb-16">
                <img src={Clear} alt="Cancel" className="cursor-pointer"  onKeyDown={closeOverLay}
              onClick={closeOverLay}
              data-testid="overlay"/>
              </div>
          
            <div className="mediaView h-88 text-center overflow-auto">
              {contentType[0] === "video" && contentType[1] !== "mpeg" && (
                <video
                  controls
                  autoPlay
                  className="enlargeImgView"
                  ref={videoRef}
                >
                  <source src={base64Data} type="video/mp4"></source>
                </video>
              )}

              {!isMpegSupportedBrowser &&
                contentType[0] === "video" &&
                contentType[1] === "mpeg" && (
                  <>
                    <video
                      controls
                      autoPlay
                      className="enlargeImgView"
                    
                    >
                      <source src={base64Data} type="video/mp4"></source>
                    </video>
                    <div className="error overlayMpeg">
                      <p>
                        Your browser doesn't support playing MPEG videos,
                        please click{" "}
                        <a download="video.mpeg" href={base64Data}>
                          here
                        </a>{" "}
                        to download the video instead.
                      </p>
                    </div>
                  </>
                )}

              {contentType[0] === "video" &&
                contentType[1] === "mpeg" &&
                isMpegSupportedBrowser && (
                  <>
                    <video
                      controls
                      autoPlay
                      className="enlargeImgView"
                      style={{ backgroundColor: "#333333", height: "99%" }}
                    >
                      <source src={base64Data} type="video/mp4"></source>
                    </video>
                    <div className="error overlayMpeg">
                      <p>
                        {t("Media_MPEG_Apple")}
                      </p>
                    </div>
                  </>
                )}

              {contentType[0] === "image" && (
                <img
                  src={base64Data}
                  alt={`thumbnail icon${crypto.getRandomValues(new Uint32Array(1))[0] % 20}`}
                />
              )}
             
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default MediaList;
